import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import SidebarEditor from '@/components/sidebar-editor/sidebar-editor'
import { sidebarsQueryOptions, availableSidebarFieldsQueryOptions, updateSidebarMutation } from '@/queries/sidebarsQueryOptions'

export const Route = createFileRoute(
    '/_app/$module_id/$entity_type_id/$entity_id/sidebar-edit',
)({
    component: RouteComponent,
})

function RouteComponent() {
    const { entity_id, entity_type_id, module_id } = Route.useParams()
    const navigate = useNavigate()

    const { data: sidebar, isLoading: sidebarLoading } = useQuery(
        sidebarsQueryOptions(entity_type_id)
    )

    const { data: availableFields = [], isLoading: fieldsLoading } = useQuery(
        availableSidebarFieldsQueryOptions(entity_type_id)
    )

    const updateSidebar = updateSidebarMutation(entity_type_id)

    const handleUpdateSidebar = (updatedSidebar: typeof sidebar) => {
        if (updatedSidebar) {
            // Let the server handle customerId and other required fields
            const sidebarToUpdate = {
                ...updatedSidebar,
                entityType: entity_type_id
            }

            updateSidebar.mutate(sidebarToUpdate, {
                onSuccess: (data) => {
                    console.log('Sidebar updated successfully:', data);
                    // Navigate back to the entity page after successful save
                    navigate({
                        to: '/$module_id/$entity_type_id/$entity_id',
                        params: { module_id, entity_type_id, entity_id }
                    });
                },
                onError: (error) => {
                    console.error('Error updating sidebar:', error);
                }
            });
        } else {
            console.error('No updatedSidebar provided');
        }
    }

    if (sidebarLoading || fieldsLoading) {
        return null;
    }

    return (
        <div className="h-full">
            <SidebarEditor
                sidebar={sidebar || null}
                availableFields={availableFields}
                onUpdateSidebar={handleUpdateSidebar}
                entityTypeId={entity_type_id}
                entityId={entity_id}
                moduleId={module_id}
                isLoading={updateSidebar.isPending}
            />
        </div>
    )
}
